// @ts-nocheck
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

document.addEventListener("DOMContentLoaded", function () {
  // Auto-resize textareas
  const textAreaForms = document.querySelectorAll(".textarea-auto-resize");
  if (textAreaForms) {
    textAreaForms.forEach((textarea) => {
      textarea.addEventListener("input", autoResize, false);
    });
  }

  function autoResize() {
    this.style.height = "auto";
    this.style.height = this.scrollHeight + "px";
  }

  const cancelKnowledgeCreate = document.getElementById("cancelKnowledgeCreate");
  if (cancelKnowledgeCreate) {
    cancelKnowledgeCreate.addEventListener("click", function () {
      $("#js-new-manual-knowledge-data-source-modal").modal("hide");
      $("#js-knowledge-data-source-select-modal").modal("show");
    });
  }

  const knowledgeForm = document.getElementById("knowledgeForm");
  if (knowledgeForm) {
    knowledgeForm.addEventListener("submit", function (event) {
      event.preventDefault();

      // clear validation error message
      document.querySelectorAll(".is-invalid").forEach((element) => {
        element.classList.remove("is-invalid");
      });
      document.querySelectorAll(".invalid-feedback").forEach((element) => {
        element.textContent = "";
      });
      // disable submit button
      document.getElementById("submitKnowledge").disabled = true;

      const axiosInstance = axios.create();
      axiosInstance.defaults.headers.common["X-CSRF-Token"] = document.getElementsByName("csrf-token")[0].content;

      const knowledge_client_code = document.getElementById("knowledge_client_code").value;
      const knowledge_base_id = document.getElementById("knowledge_base_id").value;
      const knowledgeBasePath = `/${knowledge_client_code}/knowledge_bases/${knowledge_base_id}`;

      axiosInstance
        .post(`${knowledgeBasePath}/knowledges`, {
          knowledge: {
            question: document.getElementById("knowledge_question").value,
            answer: document.getElementById("knowledge_answer").value,
            source_link: document.getElementById("knowledge_source_link").value,
          },
          is_notice_required: true,
        })
        .then((response) => {
          if (response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            const errors = error.response.data;

            // set validation error message
            Object.keys(errors).forEach((key) => {
              const inputElement = document.getElementById(`knowledge_${key}`);
              if (inputElement) {
                const feedbackElement = inputElement.nextElementSibling;
                feedbackElement.textContent = errors[key].join(", ");
                inputElement.classList.add("is-invalid");
              }
            });
            // enable submit button
            document.getElementById("submitKnowledge").disabled = false;
          }
        });
    });
  }

  const manualKnowledgeDataSourceCard = document.getElementById("js-manual-knowledge-data-source-card");
  if (manualKnowledgeDataSourceCard) {
    manualKnowledgeDataSourceCard.addEventListener("click", function (event) {
      $("#js-new-manual-knowledge-data-source-modal").modal("show");
      $("#js-knowledge-data-source-select-modal").modal("hide");
    });
  }

  const errorPopupHandler = document.querySelectorAll("[id^=js-error-popup-handler]");
  if (errorPopupHandler.length > 0) {
    errorPopupHandler.forEach((handler) => {
      // マウスが要素に入った時のイベントリスナーを追加
      handler.addEventListener("mouseenter", function () {
        const id = handler.id.replace("js-error-popup-handler-", "");
        const popup = document.getElementById(`js-error-popup-wrap-${id}`);
        // 他のすべてのポップアップを非表示にする
        document.querySelectorAll("[id^=js-error-popup-wrap]").forEach((p) => p.classList.add("d-none"));
        // 対象のポップアップを表示する
        popup.classList.remove("d-none");
      });

      // マウスが要素から出た時のイベントリスナーを追加
      handler.addEventListener("mouseleave", function () {
        const id = handler.id.replace("js-error-popup-handler-", "");
        const popup = document.getElementById(`js-error-popup-wrap-${id}`);
        // 対象のポップアップを非表示にする
        popup.classList.add("d-none");
      });
    });
  }
});
